<template>
 <loader v-if="isLoader" />
  <div class="container-fluid"  v-if="!isLoader">
    <!-- Header and Chart Row -->
    <div class="row">
      <!-- Header -->
      <div class="col-12 header">
        <div class="row">
          <div class="col-lg-3 logo-container">
              <a href="/#/" v-if="false">
            <img
              src="@/assets/images/logo-lg-light.svg"
              alt="#"
              v-if="theme == 'light'"
            />
            </a>

              <a href="/#/" v-if="false" >
            <img
              src="@/assets/images/logo-lg-medium.svg"
              alt="#"
              v-if="theme == 'medium'"
            />
            </a>

              <a href="/#/" v-if="false">
            <img
              src="@/assets/images/logo-lg-dark.svg"
              alt="#"
              v-if="theme == 'dark'"
            />
            </a>
          </div>
          <div class="col-lg-6 dash-heading-container">
            <h1 v-if="lang == 'ar'">لوحة أداء القطاع</h1>
            <h1 v-if="lang == 'en'">Sector Dashboard</h1>
            <div class="line"></div>
          </div>
          <div class="col-lg-3 custom-dropdown-container">
             <div class="arrowlogo">
               <img 
              src="@/assets/images/arrow-h-dark.png"
              alt="#"
              v-if="theme == 'dark'"/>
              <img 
              src="@/assets/images/arrow-h-medium.png"
              alt="#"
              v-if="theme == 'medium'"/>
              <img 
              src="@/assets/images/arrow-h-light.png"
              alt="#"
              v-if="theme == 'light'"/>
            </div>
            <div class="togglers">
              <lang-toggler-v3></lang-toggler-v3>
              <theme-toggler-v3></theme-toggler-v3>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 tiles-section">
        <div class="sector-tile-proto" v-for="sector in projectData.projectSector.labels" :key="sector.key" @click="navigate(`/sector-detail?key=${sector.key}`)">
          <div class="content-container">
            <img src="@/assets/images/icons/sector-icon.svg" alt="#" />
            <h1>{{ sector.key }}</h1>
            <h2 v-if="lang == 'ar'">حالة المشاریع</h2>
            <h2 v-if="lang == 'en'">Project Status</h2>
            <div class="mark-container">
               <div class="mark completed">
                {{
                  projectData.projects.filter(
                    (item) => item.ProjectStatus == "تم الاطلاق(مكتمل)" && item.ProjectSector == sector.key
                  ).length
                }}
              </div>
              <div class="mark onplanned">
                {{
                  projectData.projects.filter(
                    (item) => item.ProjectStatus == "حسب المخطط" && item.ProjectSector == sector.key
                  ).length
                }}
              </div>
              <div class="mark expectedlate">
                {{
                  projectData.projects.filter(
                    (item) => item.ProjectStatus == "متوقع التأخير/ملاحظة مهمة" && item.ProjectSector == sector.key
                  ).length
                }}
              </div>
              <div class="mark late">
                {{
                  projectData.projects.filter(
                    (item) => item.ProjectStatus == "متأخر" && item.ProjectSector == sector.key
                  ).length
                }}
              </div>
            </div>

            <img
              src="@/assets/images/icons/eng-sector-navigate.svg"
              alt="#"
              v-if="lang == 'en'"
            />
            <img
              src="@/assets/images/icons/ar-sector-navigate.svg"
              alt="#"
              v-if="lang == 'ar'"
            />
          </div>
        </div>
      </div>
    </div>

    <FooterUnfixed/>

  </div>
</template>





<script>
import store from "@/store";
import router from "@/router";

// import Swal from 'sweetalert2'
import axios from "axios"; //uncomment when using api
import ThemeTogglerV3 from "@/components/theme-toggler-v3.vue";
import LangTogglerV3 from "@/components/lang-toggler-v3.vue";
import FooterUnfixed from "@/components/footer-unfixed.vue";


// import $ from 'jquery';

// Local data fetch for testign
import { projects } from "@/static/projectdataset.js";
import { risks } from "@/static/riskprojects.js";

export default {
  name: "Sectors-dev",
  components: {
    ThemeTogglerV3,
    LangTogglerV3,
    FooterUnfixed
  },
  computed: {
    theme() {
      return store.getters.getCurrentTheme;
    },
    lang() {
      return store.getters.getCurrentLang;
    },
    env() {
      return store.getters.getEnv;
    }
  },
  data() {
    return {
       isLoader: false,
      projectData: {
        risks: [],
        projects: [],
        projectSector: {
          isData: false,
          totalSectors: 0,
          labels: [],
        },
      },
    };
  },
  methods: {
    navigate: function(page) {
       router.push(page);
    },
    calculateProjectSector: function () {
      const uniques = this.projectData.projects
        .map((item) => item.ProjectSector)
        .filter((value, index, self) => self.indexOf(value) === index);

      for (let i = 0; i < uniques.length; i++) {
        const feed = {};
        feed.key = uniques[i];
        feed.value = 0;
        this.projectData.projectSector.labels.push(feed);
      }
    },
  },
  async mounted() {

    // Fetching from api uncomment below three lines if using api
    if( this.env == 'prod' ) {
      try {
         this.isLoader = true;
        const response = await axios.get("https://pmoapi.sdb.gov.sa/api/proj/3",{withCredentials: true});
        this.projectData.projects = JSON.parse(response.data[0]);
        //this.projectData.risks = JSON.parse(response.data[1]);
         this.isLoader = false;
      } catch (error) {
        console.log(error);
      }
    }
    if( this.env =='dev' ) {
      // Fetching from local comment below three lines if using api
      this.projectData.projects = projects;
      this.projectData.risks = risks;
    }
   

    

    this.calculateProjectSector();
  },
};
</script>

<style lang="scss">
@import "@/assets/css/global.scss";

body.ar {
  direction: rtl;
}
body.en {
  direction: ltr;
}

body.theme-light {
  background: $primary-background-light-v3;
}
body.theme-dark {
  background: $primary-background-dark-v3;
}
body.theme-medium {
  background: $primary-background-medium-v3;
}
</style>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
@import "@/assets/css/common.scss";

body.theme-dark.ar {
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    padding-top: 55px;
    padding-bottom: 66px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);
      margin-bottom: 50px;
      margin-left: 45px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-left: 0px;
      }

      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-dark-secondarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #fff);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }
      }
    }
  }
}
body.theme-medium.ar {
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    padding-top: 55px;
    padding-bottom: 66px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
      margin-bottom: 50px;
      margin-left: 45px;
      cursor: pointer;
    
      &:nth-child(4n) {
        margin-left: 0px;
      }


      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-medium-primarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #000);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }
      }
    }
  }
}
body.theme-light.ar {
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    padding-top: 55px;
    padding-bottom: 66px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorder;
      box-shadow: 17px 27px 46px rgba(0, 0, 0, 0.04);
      margin-bottom: 50px;
      margin-left: 45px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-left: 0px;
      }


      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-light-primarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #000);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }
      }
    }
  }
}

body.theme-dark.en {
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    padding-top: 55px;
    padding-bottom: 66px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);
      margin-bottom: 50px;
      margin-right: 45px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-right: 0px;
      }


      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-dark-secondarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #fff);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }
      }
    }
  }
}
body.theme-medium.en {
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    padding-top: 55px;
    padding-bottom: 66px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
      margin-bottom: 50px;
      margin-right: 45px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-left: 0px;
      }


      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-medium-primarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #000);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }
      }
    }
  }
}
body.theme-light.en {
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 55px;
    padding-bottom: 66px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorder;
      box-shadow: 17px 27px 46px rgba(0, 0, 0, 0.04);
      margin-bottom: 50px;
      margin-right: 45px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-right: 0px;
      }


      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-light-primarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #000);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }
      }
    }
  }
}
</style>
